const BooksCatalog = () => import('@/views/modules/books/Catalog.vue');
const SingleBook = () => import('@/views/modules/books/SingleBook.vue');
const FavoriteBooks = () => import('@/views/modules/books/FavoriteBooks.vue');

export default [
    {
        path: '/books/catalog',
        name: 'books-catalog',
        component: BooksCatalog,
        meta: { allowedSubdomains: ["portal"] },
    },
    {
        path: '/books/:id',
        name: 'single-book',
        component: SingleBook,
        meta: { requiresAuth: true, allowedSubdomains: ["portal"] },
    },
    {
        path: '/my-profile/favorite-books',
        name: 'favorite-books',
        component: FavoriteBooks,
        meta: { requiresAuth: true, allowedSubdomains: ["portal"] },
    },
];
